// about

// quirks
import ai from "./artificialIntelligence.png"
import pa from "./predictAnalysis.png"
import ns from "./neuroScience.png"
import gm from "./gamification.png"
import lt from "./latestTech.png"
import bp from "./bestPractice.png"

// marketplaces
import craft from "./hrMaeketPlaces/craft.png"
import capterra from "./hrMaeketPlaces/capterra.png"
import g2 from "./hrMaeketPlaces/g2.png"
import crozdeck from "./hrMaeketPlaces/crozdeck.png"
import softSuggest from "./hrMaeketPlaces/softwareSuggest.png"

// import locations from './locations.png'

import bannerArtScreen from "./bannerArtScreen.png"
// import heroArt from "./heroArt.png"
// import heroArtMobile from "./heroArtMobile.png"
import bannerArt from "../home/statsBanner/bannerArt.png"
import bannerArt2 from "../home/statsBanner/bannerArt2.png"


// stats assets
// import gameController from "../home/statsBanner/gameController.png"
// import globe from "../home/statsBanner/globe.png"
// import handshake from "../home/statsBanner/handshake.png"
// import user from "../home/statsBanner/user.png"

// import heroBg from "./heroBg.png"

// import locationMarker from "./marker.png"

// import map from "./imageMap/Map.png"
// import canada from "./imageMap/Canada.png"
// import pakistan from "./imageMap/Pakistan.png"
// import singapore from "./imageMap/Singapore.png"
// import mobileMap from "./imageMap/mobileMap.png"


const aboutPageAssets= {

    ai,
    pa,
    ns,
    gm,
    lt,
    bp,


    craft,
    capterra,
    g2,
    crozdeck,
    softSuggest,

    // gameController,
    // globe,
    // handshake,
    // user,
    bannerArtScreen,
    bannerArt,
    bannerArt2,
    // heroArtMobile,
    // locations,
    // heroBg
    // locationMarker,

    // map,
    // canada,
    // pakistan,
    // singapore,
    // mobileMap


}

export default aboutPageAssets
